import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons'
import Menudata from '../../data/menu'
import { Container, Row } from 'react-bootstrap'
import AnchorLink from 'react-anchor-link-smooth-scroll'

function Menu() {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const [activeClass, setactiveClass] = useState(false);
    const [active, setActive] = useState();

    React.useEffect(() => {
        window.addEventListener('scroll', () => {
            let scoll = null
            if(window.scrollY === 0){
                scoll = false
            }else{
                scoll = true
            }
            setactiveClass(scoll)
        });
    }, [])

    const ScrollMenu =[];
    Menudata.map((data,i) =>
        ScrollMenu.push(data.href.slice(1))
    )

    const activeLink = (link) => {
        toggle()
        setActive(link)
        return 100;
    }
  
    return (
        <header id="header" className={activeClass ? 'sticky' : ''}>
            <nav className="navbar navbar-wrapper">
                <div className="logo-menu-wrapper">
                    <Container>
                        <Row>
                            <div className="col-sm-6 col-6">
                                <div className="logo-box">
                                <a className="logo-wrapper" href="/">
                                    <img src={require('../../assets/images/logo.png')} alt="" title="" />
                                </a>
                                </div>
                            </div>
                            <div className="col-sm-6 col-6">
                                <div className="sidebar-toggle">
                                    <button type="button" id="navbar-menu-btn" onClick={toggle} className="btn navbar-toggler">
                                        <span className="navbartoggler-icon"><FontAwesomeIcon icon={faAlignLeft} /> </span>
                                    </button>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
                <div className={isOpen ? 'open' : ''} id="sidebar">
                    <div className="sidebar-overlay"></div>
                    <div className="sidebar-wrapper">
                        <div className="slidebar-title-wrapper">
                            <div className="slidebar-title">
                            <h6>Menu</h6>
                            <span id="slidebar-close-btn" onClick={toggle}><i className="fas fa-times-circle"></i></span>
                            </div>
                        </div>
                        <div className="navbar-link-wrapper">
                            <ul className="navbar-nav navbar-menu-frist" id="menu-navbar" >
                                {Menudata.map((file,index) => (
                                    <li key={index}  className={`nav-item-box ${active === file.href ? 'active' : '' }`}>
                                        <AnchorLink offset={() => activeLink(file.href)}  href={file.href}>{file.title}</AnchorLink ></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}


export default Menu